export default __webpack_public_path__ + "34a71e3fbe3ac6bc6cdddeabcf1fc65f.png";